module.exports = __webpack_public_path__ + "media/images/how-it-works/directduel/step-2-61f994b51d3633217966baa1d94fe486.png";